import {
  FeatureFlagUpsertCommandFeatureEnum,
  type OrderGetOrderDetailsReadDto,
} from "@/config/apiClient";
import { RetroplanningStatusEnum } from "@/config/apiClient.types";
import { checkRetroplanningActionAlreadyDone } from "@/helpers/retroplanningHelpers";
import { useGetIsFeatureActive } from "./useGetIsFeatureActive";

// Create an array with disabled/hidden states for each Retroplanning Status
export const useGetRetroplanningStatusAvailability = (
  order: OrderGetOrderDetailsReadDto | undefined,
  orderItemId: string
): {
  status: RetroplanningStatusEnum;
  disabled: boolean;
  hidden: boolean;
}[] => {
  const { isActive: isPurchaseOrderFeatureActive } = useGetIsFeatureActive(
    FeatureFlagUpsertCommandFeatureEnum.PurchaseOrder
  );

  return Object.values(RetroplanningStatusEnum).map(
    (status: RetroplanningStatusEnum) => {
      return {
        status: status,
        disabled: order
          ? checkRetroplanningActionAlreadyDone(status, order, orderItemId)
          : false,
        hidden:
          status === RetroplanningStatusEnum.PURCHASE_ORDER_MISSING &&
          !isPurchaseOrderFeatureActive,
      };
    }
  );
};
